module.exports = {"unspecified":"Non specificato","horde":"Orda","alliance":"Alleanza"};